import { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { FetchStatuses } from 'builder/modules/constants'
import {
  AutoTailoringFromPublicJobBoardStep,
  actions,
  AutoTailoringMode,
  parseAutoTailoringUrlParams,
} from 'builder/modules/resumeEditor'

export const useAutoTailoringFromJobBoard = (resumeId: number) => {
  const dispatch = useDispatch()
  const location = useLocation()

  const { mode, autotailoringStep, jobCardId, jobPostingId } = useMemo(() => {
    return parseAutoTailoringUrlParams(location.search)
  }, [location.search])

  useEffect(() => {
    if (!resumeId) {
      return
    }

    if (!mode) {
      dispatch(actions.resetAutoTailoringForPublicJobBoard())
      return
    }

    const isReviewStep = autotailoringStep === AutoTailoringFromPublicJobBoardStep.step2

    dispatch(
      actions.setAutoTailoringForPublicJobBoard({
        mode,
        enabled: true,
        processingAutoTailoring: isReviewStep ? FetchStatuses.loaded : FetchStatuses.notAsked,
        jobCardId: jobCardId,
        jobPostingId,
        ...(autotailoringStep ? { step: autotailoringStep } : {}),
      }),
    )
  }, [dispatch, resumeId, mode, autotailoringStep, jobCardId, jobPostingId])

  useEffect(() => {
    if (
      mode === AutoTailoringMode.fromMemberJB &&
      jobPostingId &&
      (!autotailoringStep || autotailoringStep === AutoTailoringFromPublicJobBoardStep.step1)
    ) {
      dispatch(
        actions.initAutoTailoringFromMemberJobBoard({
          jobPostingId,
        }),
      )
    }
  }, [dispatch, mode, jobPostingId, autotailoringStep])

  // reset state to prevent future bugs on component unmount
  useEffect(() => {
    return () => {
      dispatch(actions.resetAutoTailoringForPublicJobBoard())
    }
  }, [dispatch])
}
